// 9fbef606107a605d69c0edbcd8029e5d
import getAddresses from '@tcp/core/src/queries/getCustomerAddress.query.graphql';
import { parseBoolean } from '../../../utils/utils';
import { executeStatefulGraphQLQuery } from '../../handler';

export function formatAddressBookResponse(
  arr,
  defaultBillingId,
  defaultShippingId,
  paymentInstruments
) {
  let containsDefault = false;
  const addresses = arr.map((address) => {
    containsDefault = containsDefault || parseBoolean(address.preferred);
    const defaultBilling = address;
    defaultBilling.xcont_isDefaultBilling = 'false';
    defaultBilling.preferred = 'false';
    defaultBilling.creditCard = 'false';
    if (address.addressId === defaultBillingId) {
      defaultBilling.xcont_isDefaultBilling = 'true';
    }
    if (address.addressId === defaultShippingId) {
      defaultBilling.preferred = 'true';
    }

    const paymentsArray = paymentInstruments.filter((a) => a.c_addressId != null);

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < Object.keys(paymentsArray).length; i++) {
      if (address.addressId.indexOf(paymentsArray[i].c_addressId) > -1) {
        defaultBilling.creditCard = true;
        break;
      }
    }

    return {
      ...address,
    };
  });
  if (!containsDefault && addresses.length) {
    addresses[0].preferred = 'true';
  }
  return addresses;
}

const getAddressListData = () => {
  return executeStatefulGraphQLQuery({
    query: getAddresses,
    fetchPolicy: 'no-cache',
  })
    .then((res) => {
      return formatAddressBookResponse(
        res?.data?.getCustomer?.addresses || [],
        res?.data?.getCustomer?.billingAddressId,
        res?.data?.getCustomer?.shippingAddressId,
        res?.data?.getCustomer?.paymentInstruments || []
      );
    })
    .catch((err) => {
      throw err;
    });
};

export default getAddressListData;
